import { Routes, Route } from 'react-router-dom'
import AssetExplorer from './modules/assets/components/AssetExplorer'
import DashboardView from './modules/dashboards/components/DashboardView'
import { DashboardViewerPage, DashboardBuilderPage } from './modules/dashboards/pages'
import AdminPage from './modules/admin/pages/AdminPage'
import AssetsPage from './modules/assets/pages/AssetsPage'
import AssetDiscoveryPage from './modules/assets/pages/AssetDiscoveryPage'

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<DashboardView />} />
      <Route path="/assets" element={<AssetsPage />} />
      <Route path="/assets/discover" element={<AssetDiscoveryPage />} />
      <Route path="/assets/legacy" element={<AssetExplorer />} />
      <Route path="/dashboards" element={<DashboardView />} />
      <Route path="/dashboards/:id" element={<DashboardViewerPage />} />
      <Route path="/dashboards/:id/edit" element={<DashboardBuilderPage />} />
      <Route path="/admin" element={<AdminPage />} />
    </Routes>
  )
}